module.exports = __webpack_public_path__ + "img/reidar_fristilt.1c9cf0f4.png";